import React, { FunctionComponent } from 'react'
import { ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'

import {
  RTFBlockComponentProps,
  RTFBlockComponentExport,
  ObjectWithUnknownProperties,
} from '../../types'

import {
  contentfulTooltip,
  contentfulTooltipTitle,
  contentfulTooltipBody,
} from './index.module.scss'

export interface RTFContentfulTooltipGraphQLResult
  extends ContentfulRichTextGatsbyReference {
  __typename: EF.RTFBlockTypename.ContentfulTooltip
  title: string
  body: {
    body: string
  }
}

export interface ContentfulTooltipBlockProps extends RTFBlockComponentProps {
  title: string
  body: {
    body: string
  }
}

const ContentfulTooltipBlock: FunctionComponent<ContentfulTooltipBlockProps> = ({
  title,
  body: { body },
}) => {
  return (
    <aside className={contentfulTooltip}>
      <strong className={contentfulTooltipTitle}>{title}</strong>
      <p className={contentfulTooltipBody}>{body}</p>
    </aside>
  )
}

const componentExport: RTFBlockComponentExport = {
  component: ContentfulTooltipBlock,
  isValid: ({ title, body }) =>
    !!title && !!body && !!(body as ObjectWithUnknownProperties).body,
}

export default componentExport
